<div class="finances-debt-container">
    <div class="title-medium capitalize">{{ debtContext }} debt</div>
    <div class="dscr-debt-schedule">
        @if (debtScheduleItems()?.length) {
            @for (item of debtScheduleItemsData(); track item.id; let last = $last) {
                <div class="dscr-year-debt-schedule-section" [class.last]="last">
                    <div class="column-grid justify-between place-items-center pt-2.5">
                        <div class="title-medium">{{ item.lenderName }}</div>
                        <div class="lendio-density-2">
                            <button mat-flat-button
                                    color="accent"
                                    (click)="editDebtScheduleItem(item.id)">
                                Edit
                            </button>
                        </div>
                    </div>
                    <div class="debt-schedule-items" GridTopBottomIdentifier>
                        @for (property of item | keyvalue; track property) {
                            @if (property?.key && property.key !== 'lenderName' && property.key !== 'id') {
                                <div class="debt-schedule-item-row" #DscrGridItem>
                                    <div class="dscr-label">
                                        {{ property.key.toString() | camelToSentence }}
                                    </div>
                                    <div class="dscr-label value">
                                        {{ (property?.value?.toString()) || '-' }}
                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
            }
        } @else {
            <div class="title-medium empty-state"> No debt schedule items</div>
        }
        <div class="flex flex-row my-4 mx-6"
             [ngClass]="debtScheduleItems()?.length ? 'justify-start' : 'justify-center'">
            @if (canEditDscrData()) {
                <button mat-button
                        (click)="newDebtScheduleItem()"
                        color="primary">
                    <mat-icon matPrefix color="primary">add</mat-icon>
                    Add debt schedule item
                </button>
            }
        </div>
    </div>
</div>
